import React from 'react';
import {Button, CircularProgress, Stack} from "@mui/joy";
import BaseApi from "../../utils/BaseApi";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import InfoIcon from "@mui/icons-material/Info";
import CommonInfoTab from "../Common/CommonInfoTab";
import {isDictionary} from "../../utils/misc";


class ApplicantExternalTab extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            fields: [],
            loading: true,
            processing: false,
            updatePermission: null,
            applicant: this.props.applicant,
        };
        this.fieldsList = [
            'approved',
            'position', 'subscriber_type', 'salary', 'salary_occupation', 'staff', 'first_work_day', 'last_work_day',
            'last_name', 'first_name', 'patronymic', 'last_name_eng', 'first_name_eng', 'sex', 'birthdate', 'birthplace',
            'phone', 'email',
            'inn', 'inn_file',
            'snils', 'snils_file',
            'citizenship', 'passport_number', 'passport_date', 'passport_issuer', 'passport_registration', 'passport_file',
            'employment_history',
            'school', 'specialization', 'course', 'school_end_year', 'diploma_file',
            'bank_name', 'bank_bik', 'bank_corr_account', 'bank_check_account',
        ];
    }

    async componentDidMount() {
        await this.retrieveFields();
        await this.retrieveUpdatePermission();
    }

    async retrieveApplicant() {
        this.setState(
            {
                applicant: null
            }
        );
        const url = `applicant/${this.state.applicant.id}/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                applicant: response.data
            }
        );
    }

    async retrieveFields() {
        const api = new BaseApi();
        const params = {
            fields: JSON.stringify(this.fieldsList)
        };
        const url = `applicant/update_form/`;
        
        try {
            const response = await api.get(url, params);
            this.setState({
                fields: response.data,
                loading: false
            });
        } catch (e) {
            console.error(e);
            this.setState({ loading: false });
        }
    }

    async retrieveUpdatePermission() {
        let p = await retrievePermission(
            'ApplicantViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        this.setState({ updatePermission: p });
    }

    handleProcessJob = async () => {
        this.setState({ processing: true });
        const api = new BaseApi();
        try {
            const response = await api.post(`applicant/${this.state.applicant.id}/job_process/`, {});
            if (response.status === 200) {
                if (this.props.callBack) {
                    await this.props.callBack(response.data);
                }
            }
        } catch (e) {
            alert('Ошибка при запуске процесса');
            this.setState({ processing: false });
        }
    }

    render() {
        if (this.state.loading || !this.state.applicant || this.state.updatePermission === null) {
            return <CircularProgress />;
        }

        const showJobProcessButton = this.state.applicant.approved && !this.state.applicant.processed;

        let infoFields = this.state.fields.slice(0, -1).map(
            (f) => ({
            title: f.label,
            value: isDictionary(this.state.applicant[f.name]) ?
                this.state.applicant[f.name].system_title:
                this.state.applicant[f.name],
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            html: f.type === 'textarea',
            file: f.type === 'file'? {
                    url: 'applicant',
                    id: this.state.applicant.id,
                    field: f.name
                }:
                null,
            edit: {
                permission: this.state.updatePermission,
                fields: [f.name, ],
                baseUrl: 'applicant',
                obj: isDictionary(this.state.applicant[f.name]) ?
                    {
                        'id': this.state.applicant.id,
                        [f.name]: this.state.applicant[f.name].id
                    }:
                    this.state.applicant
            }
        })
        )

        return (
            <Stack spacing={3}>
                {showJobProcessButton && (
                    <Stack direction="row" spacing={2}>
                        <Button
                            variant="solid"
                            color="success"
                            onClick={this.handleProcessJob}
                            disabled={this.state.processing}
                        >
                            {this.state.processing ? 'Обработка...' : 'Запустить процесс трудоустройства'}
                        </Button>
                    </Stack>
                )}

                <CommonInfoTab
                    callBack={this.retrieveApplicant.bind(this)}
                    groups={
                        [
                            {
                                title: 'Информация для приема',
                                icon: <InfoIcon />,
                                fields: infoFields
                            }
                        ]
                    }
                />

            </Stack>
        );
    }

}

export default ApplicantExternalTab;
